import { Injectable } from '@angular/core';
import { InputSurgeArrestor, BaseResponseDTO, DefaultService } from '@psnb/psnb-api';
import {Observable} from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InputSurgeArrestorService {

  constructor(private powerSupplyService: DefaultService) {
    this.getAllInputSurgeArrestorFromService();
  }

  getAllInputSurgeArrestorFromService() {
    return this.powerSupplyService.getInputSurgeArrestors().pipe(map(result => result));
  }
  createInputSurgeArrestor(inputSurgeArrestor: InputSurgeArrestor) {
    return this.powerSupplyService.createInputSurgeArrestor(inputSurgeArrestor).pipe(map(result => result));
  }

  updateInputSurgeArrestor (inputSurgeArrestor: InputSurgeArrestor) {
    return this.powerSupplyService.updateInputSurgeArrestor(inputSurgeArrestor).pipe(map(result => result));
  }

  deleteInputSurgeArrestor(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deleteInputSurgeArrestor(id).pipe(map(result => result));
  }
}

